/** @format */

import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
	selector: '[highlightKeyword]'
})
export class HighlightKeywordDirective implements AfterViewInit {
	@Input('highlightKeyword') selectedSearch = '';

	constructor(private el: ElementRef) {}

	ngAfterViewInit(): void {
		this.highlightText(this.selectedSearch);
	}

	/**
	 *
	 * @param text
	 * Replaces globally the matches
	 */
	private highlightText(text: string): void {
		const content: string = this.el.nativeElement.innerHTML;
		if (text) {
			const regex = RegExp(`${text}`, 'gi');
			const newElement = content.replace(regex, (match) => `<strong>${match}</strong>`);
			this.el.nativeElement.innerHTML = newElement;
		}
	}
}
